import { IMessageType } from '@/services/signalr/types';
import { IUnitEteReqMsg } from '~/api/messages/IUnitEteReqMsg';
import { IUnitEteRespMsg } from '~/api/messages/IUnitEteRespMsg';

export const UnitEte: IMessageType<IUnitEteReqMsg, IUnitEteRespMsg> = {
  requestName: 'UnitEteReqMsg',
  responseName: 'UnitEteRespMsg',
};
